import { themeToggleColorScheme } from "./parts/themeToggleColorScheme";
import { ready } from "./utils";
import 'flowbite';
import { vacationSliders } from './parts/sliders';
import { updateVacationStatus } from './parts/updateVacationStatus';
import { initVacationRequestDeleter } from './parts/deleteVacationRequest';

console.log('parent scripts included')

themeToggleColorScheme();
ready(() => {
  vacationSliders();
  updateVacationStatus();
  initVacationRequestDeleter();
});